import { Box, Typography } from "@mui/material";
import BrandedLoadingIndicator from "./BrandedLoadingIndicator";

interface RouteLoadingFallbackProps {
  label: string;
}

const RouteLoadingFallback = ({ label }: RouteLoadingFallbackProps) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      mt: 10,
      gap: 2,
    }}
  >
    <BrandedLoadingIndicator />
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
  </Box>
);

export default RouteLoadingFallback;
